import { createContext } from 'react';

import type { Tab } from './types';

const TabsContext = createContext<{
  tabs: Tab[];
  selectedTabId?: StringNumberValue | null;
}>({
  tabs: [],
  selectedTabId: null,
});

export default TabsContext;
